<template>
  <div class="homephone" style="width: 100%;margin: auto;min-height: 480px;padding-top: 0px">
<!--    <div class="col-tital"> <div class="col-tital-main">政 策 <span style="color: #0a76a4">咨 讯</span></div><div class="col-tital-minor">汇集政策热点 详实政策解读</div></div>-->
   <div class="banner">
     <div class="cxslgphone"> <p class="cxslgphone_title1">信用查询</p>
             <el-form ref="formInline" :inline="true" :model="formInline" :rules="rules" class="demo-form-inline centered-form">
        <el-form-item style=""  prop="companyName">
          <el-input style="height: 52px;  border-radius:8px;width: 350px" v-model="formInline.companyName" placeholder="请输入企业名称" ></el-input>
        </el-form-item>
         <el-form-item style=""  prop="coding">
          <el-input style="height: 52px;  border-radius:8px;width: 350px" v-model="formInline.coding" placeholder="请输入证书编号" ></el-input>
        </el-form-item>
        <el-form-item style="">
          <el-button style="background-color:#ffa740;border:#ffa740;height: 52px;width: 150px;" type="primary" @click="checkForm('formInline')"   @keyup.enter.native="checkForm('formInline')">
            <span style="color:#713c03;font-size: 18px">公示查询</span>
          </el-button>
        </el-form-item>
      </el-form>
       </div>
   </div>
<!--    查询版-->
    <div v-if="showtable===1" class="companyInfophone">
<el-row>
  <el-col :span="4"><div class="grid-content bg-purple">企业名称</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.companyName}}</div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple">统一社会信用代码</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.creditCode}}</div></el-col>
</el-row>
      <el-row>
  <el-col :span="4"><div class="grid-content bg-purple">证书编号</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.coding}}</div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple">信用等级</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">AAA</div></el-col>
</el-row>
            <el-row>
  <el-col :span="4"><div class="grid-content bg-purple">法人代表(姓名)</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.legalPerson}}</div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple">注册资金</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.registerMoney}}</div></el-col>
</el-row>
            <el-row>

                <el-col :span="4"><div class="grid-content bg-purple">企业类型</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.economicType}}</div></el-col>
                <el-col :span="4"><div class="grid-content bg-purple">登记机关</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.registrationAuthority}}</div></el-col>

</el-row>
      <el-row>
  <el-col :span="4"><div class="grid-content bg-purple">企业地址</div></el-col>
  <el-col :span="20"><div class="grid-content bg-purple-light">{{company.companyAddress}}</div></el-col>
</el-row>
            <el-row>
  <el-col :span="4"><div class="grid-content bg-purple">有效期始</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.codingStartTime}}</div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple">有效期至</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.codingEndTime}}</div></el-col>
</el-row>
                  <el-row>
  <el-col :span="4"><div class="grid-content bg-purple">经营期限开始时间</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">{{company.startTime}}</div></el-col>
                      <el-col :span="4"><div class="grid-content bg-purple">评级机构</div></el-col>
  <el-col :span="8"><div class="grid-content bg-purple-light">北京冠捷时速信用管理有限责任公司</div></el-col>

</el-row>
            <el-row>
  <el-col :span="4" class="left-col"><div class="grid-content bg-purple" style="border: 0px">经营范围</div></el-col>
  <el-col :span="20"><div class="grid-content bg-purple-light">{{company.scopeBusiness}}</div></el-col>
</el-row>
    </div>
    <div v-if="showtable===1" style="width: 95%;margin: auto;padding-bottom: 40px">
         <el-table
    :data="list"
    border
    style="width: 100%">
    <el-table-column
      prop="certificateName"
      label="证书名称"
      >
    </el-table-column>
               <el-table-column
      prop="level"
      label="信用等级" width="80">
    </el-table-column>
    <el-table-column
      prop="coding"
      label="证书编号"
    >
    </el-table-column>
  </el-table>
     </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getCertificateQuery } from '@/api/search'
export default {
  name: 'Home',
  components: {
    Pagination
  },
  data () {
    return {
      channel: [],
      list: [],
      company: {},
      showtable: 0,
      listLoading: true,
      index: '',
      sortIndex: 0,
      carouselIndex: 0,
      currentPage: 1,
      limit: 10,
      total: 0,
      formInline: {
        companyName: '',
        coding: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        coding: [
          { required: true, message: '请输入证书编号', trigger: 'blur' },
          { min: 14, max: 16, message: '请输入正确编号', trigger: 'blur' }

        ]
      },
      lv: 1
    }
  },
  created () {
    let that = this
    if (that.$route.query.coding) { this.submitFormAtCreated() }
  },
  methods: {
    submitForm () {
      let that = this
      console.log(that.$route.query)
      if (that.$route.query.coding) {
        that.formInline.coding = that.$route.query.coding
        that.formInline.companyName = that.$route.query.companyName
      }

      getCertificateQuery(this.formInline).then(function (response) {
        if (response.result === 1) {
          that.showtable = 1
          that.company = response.data.company
          that.list = response.data.certificateList
          that.list = that.list.map(cert => {
            return {
              ...cert,
              certificateName: cert.certificateName.replace('（三）', '').replace('行业诚信单位证书', '行业诚信单位等级证书').replace('质量服务诚信单位证书', '质量、服务诚信单位证书').replace('诚信企业家', '诚信企业家证书').replace('诚信经营示范单位', '诚信经营示范单位证书').replace('重合同守信用企业', '重合同守信用企业证书')
            }
          })
          that.list = that.list.slice().sort((a, b) => {
            // 定义一个函数，用于从 coding 中提取 Y 值（即（X-Y）中的 Y）
            const extractY = coding => {
              const match = coding.match(/(\d+)-(\d+)/) // 匹配（X-Y）格式
              if (match) {
                // 从匹配结果中提取 Y 值，并将其转换为整数
                return parseInt(match[2], 10)
              } else {
                // 如果没有匹配到，可以返回一个默认值（这里返回 Infinity 表示最大值，放在排序末尾）
                // 或者根据需求抛出错误
                return Infinity
              }
            }

            // 使用提取的 Y 值对证书进行排序
            return extractY(a.coding) - extractY(b.coding)
          })
          // 3. 新增过滤逻辑：移除含"铜牌"的项目
          that.list = that.list.filter(item =>
            !item.certificateName.includes('铜牌')
          )
          that.list.forEach(item => {
            item.level = 'AAA'
          })
        }
        // eslint-disable-next-line handle-callback-err
      }).catch(function (error) {
        that.$message({
          message: '无结果，请输入有效企业名称或信用代码',
          type: 'warning'
        })
      })
    },
    submitFormAtCreated () {
      let that = this
      console.log(that.$route.query)
      that.formInline.coding = that.$route.query.coding
      that.formInline.companyName = that.$route.query.companyName
      getCertificateQuery(this.formInline).then(function (response) {
        if (response.result === 1) {
          that.showtable = 1
          that.company = response.data.company
          that.list = response.data.certificateList
          that.list = that.list.map(cert => {
            return {
              ...cert,
              certificateName: cert.certificateName.replace('（三）', '')
            }
          })
          that.list = that.list.slice().sort((a, b) => {
            // 定义一个函数，用于从 coding 中提取 Y 值（即（X-Y）中的 Y）
            const extractY = coding => {
              const match = coding.match(/(\d+)-(\d+)/) // 匹配（X-Y）格式
              if (match) {
                // 从匹配结果中提取 Y 值，并将其转换为整数
                return parseInt(match[2], 10)
              } else {
                // 如果没有匹配到，可以返回一个默认值（这里返回 Infinity 表示最大值，放在排序末尾）
                // 或者根据需求抛出错误
                return Infinity
              }
            }

            // 使用提取的 Y 值对证书进行排序
            return extractY(a.coding) - extractY(b.coding)
          })
          // 3. 新增过滤逻辑：移除含"铜牌"的项目
          that.list = that.list.filter(item =>
            !item.certificateName.includes('铜牌')
          )
          that.list.forEach(item => {
            item.level = 'AAA'
          })
        }
        // eslint-disable-next-line handle-callback-err
      }).catch(function (error) {
        that.$message({
          message: '无结果，请输入有效企业名称或信用代码',
          type: 'warning'
        })
      })
    },
    checkForm (form) {
      let that = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log('校验成功!')
          that.submitForm()
        } else {
          console.log('提交失败')
          return false
        }
      })
    },
    onSubmitxy (formInline) {
      var that = this
      var ename = that.formInline.eName
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/creditSearchAll.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
    },
    onSubmitrz () {
      var that = this
      var ename = that.formInline.eName1
      console.log(that.formInline)
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        console.log(valid)
        if (valid) {
          window.location.href = '/static/rzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSubmitzz () {
      var that = this
      var ename = that.formInline.eName2
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/zzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    onButton1 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 1
    },
    onButton2 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 2
    },
    onButton3 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 3
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleSizeChange (val) {
      this.limit = val
      this.currentPage = 1
      this.fetchData()
    },
    handleClick (id) {
      window.location.href = '/static/xxgsjg.html' + '?entid=' + id
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
  .cxslgphone{
    width: 100%;
    margin: auto;
    padding-top: 150px;
  }
  .cxslgphone_title1{
    text-align: center;
    font-size: 30px;
    color: #ffffff;
    margin: 0px 0px 80px 0px;
  }
    .cxslgphone_title2{
      margin: 20px 0px 0px 0px;
    font-size: 40px;
    color: #ffffff;
  }
  .companyInfophone {
    width: 95%;margin:40px auto 40px
  }

</style>
<style>
  /*.homephone{background: url(../../assets/img/dingbak.png) no-repeat center;background-size:100% 100%;}*/
  .el-main{
    padding: 0px !important;
    /*background-color: #f5f5f500;*/

  }
   .listNews{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 28px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #444444;
  }
  .listNews1{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 18px;
    font-weight: normal;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #555555;
  }
  .box-title{    width: 100%;
    margin: auto;    border-bottom: 2px solid #e5e5e5;}
  .box-title  strong {
    font-size: 20px ;
    margin-left: 10px;
    margin-bottom: 8px;
    line-height: 26px;
    height: 50px;
    border-bottom: 2px solid #d80026;
    text-indent: 0.5em;
    color: #d80026;

}
  .box-title  strong a{
    color: #d80026;
    text-decoration: none;
    cursor: pointer;
  }
  .recommend4 a{    text-decoration: none;
    cursor: pointer;
  color: #555;
      white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
  .recommend4 li{line-height: 40px;width: 98%;overflow: hidden;text-overflow:ellipsis}
  .recommend3 li:nth-of-type(3n - 2) a, .recommend4 li:nth-of-type(6n - 5) a, .recommend5 li:nth-of-type(5n - 4) a, .recommend6 li:nth-of-type(6n - 5) a, .recommend7 li:nth-of-type(7n - 6) a {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    background: none;

}
    .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .searchbar{
    margin: auto;
    width: 800px;
    top: 50%;
  }
  .h1title{
    text-align:center;color: #1065c0;font-size: 30px;font-weight: 700;margin-bottom: 60px
  }
  .abb{
    width: 800px;
    margin: 0px auto 20px;
    text-align: center;

  }
  .homephone .abb .el-button{
    border:0px !important;
    font-size: 22px !important;
    color: #409eff !important;
    font-weight: bold !important;
  }
    .homephone .abb .el-button:hover{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff;
  }
      .homephone .abb .el-button:visited{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
        .homephone .abb .el-button:active{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homephone .abb .el-button:focus{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homephone .el-form-item__content {
    margin-left: 0px !important;
  }
  .homephone   .el-input__inner{
    height: 50px !important;
  }
.banner {
    background-image: url(../../assets/img/bg1.jpg);
    background-size: cover;
    background-position: center;
    height: 560px;
    overflow: hidden;
}
  .bottonbanner{
    background: url(../../assets/img/backbanner.png) no-repeat center;background-size:100% 100%;
  }
  .col-tital {
  width: 1250px;
  margin: auto;
  text-align: left;
  }
.col-tital-main{
  text-align: center;
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 40px;
  font-weight: bold;
  font-family: "微软雅黑 ";
}
.col-tital-minor{
  font-size: 14px;
  font-family: "微软雅黑 Light";
  margin-top: 10px;
  margin-bottom: 40px;
  color: #aaaaaa;
}
  .col-con{
    width: 1250px;
    margin: auto;
    height: 340px;
    /*margin-top: 10px;*/
  }
  .col-con ul{
    list-style-type: none;
    float: left;
    /*margin-left: -25px;*/
  }
  .col-con li{
    box-sizing: inherit;
    width: 540px;
    line-height: 30px;
    font-size: 16px;
    color: #333333;
    border-bottom: 1px #cccccc dashed;
    margin-bottom: 15px;
  }
      .col-con-left{
    float: left;
      width: 585px;
        margin-right: 15px;
        background: #ffffff;
        padding: 5px;
  }
    .col-con-left-tital{
    float: left;
      width: 575px;
      margin: 15px;
  }
  .col-con-left-tital-main{
    float: left;
    font-size: 20px;
    font-family: "微软雅黑 ";
    font-weight: bold;
    line-height: 24px;
  }
    .col-con-left-tital-min{
      font-family: "微软雅黑 ";
    float: right;
      font-size: 14px;
      color: #888888;
      line-height: 24px;
      margin-right: 30px;
  }
  .col-con-right{
        float: right;
      width: 585px;
        margin-left: 15px;
    background: #ffffff;
     padding: 5px;
  }
  .col-con-tital-tiao{
    float: left;
        border-style: none;
    width: 5px;
    height: 24px;
    margin-right: 8px;
  }
  .col-con-li-title{
    width: 450px;
    float: left;
        overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 20px;
    color: #333333;
  }
  .col-con-li-title-r{
    float: right;
  }
  .col-com-li-time{
    font-size: 14px;
    color:#888888;
    margin-bottom: 10px;
  }
  .col-con-ser-img {
    display: flex;
    /*background: #ffffff;*/
    /*height: 200px;*/
  }
  .col-con-ser-img img{
    width: 210px;
    height: 112px;
    margin: 15px;
  }
  .col-yqlj img{
    margin: 20px 0px 20px 45px;
    width: 240px;
    height: 95px;
  }
    .bg-purple {
    background: #edfcff;
      padding-left: 20px;
  }
  .bg-purple-light {
    background: #ffffff;
    padding-left: 10px;
  }
  .grid-content {
    border-radius: 0px;
    min-height: 45px;
    font-size: 14px;
    line-height: 45px;
    border: 1px #e5e5e5 solid;
  }
  .el-row {
  display: flex; /* 使用 flex 布局 */
}

.left-col {
  border: 1px #e5e5e5 solid;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中（如果需要） */
  background-color: #edfcff; /* 示例背景色 */
  height: auto; /* 高度自动调整 */
}
.centered-form {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;    /* 垂直居中（如果需要的话） */
    flex-wrap: wrap;        /* 允许子元素换行 */
}

.centered-form .el-form-item {
    margin: 0 30px; /* 给表单项之间添加一些间距 */
}
</style>



// WEBPACK FOOTER //
// src/view/search/mobileDetails.vue